/** @format */

import React, { useState } from 'react';
import { lazy, Suspense } from 'react';
import './App.css';
import ResultadosAlumnos2 from './components/ResultadosAlumnos2';
import SwiperNews from './components/SwiperNews';

const SimpleModal = lazy(() => import('./components/modals/SimpleModal'));
const Navbar = lazy(() => import('./components/NavBar'));
const SwipersHome = lazy(() => import('./components/SwipersHome'));
const Especialistas = lazy(() => import('./components/Especialistas'));
const HeaderForm = lazy(() => import('./components/HeaderForm'));
const QuienesSomos = lazy(() => import('./components/QuienesSomos'));
const MastersHome = lazy(() => import('./components/MastersHome'));
const Gallery = lazy(() => import('./components/Gallery'));
const Alinazas = lazy(() => import('./components/Alianzas'));
const FAQ = lazy(() => import('./components/FAQ'));
const Counseling = lazy(() => import('./components/Counseling'));
const FooterNew = lazy(() => import('./components/FooterNew'));

function App() {
	const [close, setClose] = useState(false);

	const handlerClose = () => {
		close ? setClose(false) : setClose(true);
	};

	const handleCloseModal = (event) => {
		if (event.target.className === 'Inscriptions ') {
			setClose(true);
		}
	};

	return (
		<main className='App'>
			<Suspense
				fallback={
					<div
						style={{
							background: 'black',
							width: '100%',
							height: '100vh',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<div className='spinner'></div>
					</div>
				}
			>
				{/* <SimpleModal
					close={close}
					handlerClose={handlerClose}
					handleCloseModal={handleCloseModal}
				/> */}
				<Navbar />
				<HeaderForm />
				<SwipersHome />
				<Especialistas />
				<QuienesSomos />
				<ResultadosAlumnos2 />
				<SwiperNews />
				<MastersHome />
				{/* <Gallery /> */}
				<Alinazas />
				<FAQ />
				<Counseling />
				<FooterNew />
			</Suspense>
		</main>
	);
}

export default App;
